// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.WaybillNumber[data-v-5ceab1ac] {\n  color: #00A551;\n  cursor: pointer;\n}\n.ml[data-v-5ceab1ac] {\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
